import React, { useEffect, useState } from 'react';
import { useToggle } from 'react-use';
import { theme } from '@noths/polaris-client-styles';
import { useLineCount } from '@noths/polaris-client-utils';

import { ExpandableReadMoreButton } from 'src/components/molecules/ExpandableReadMoreButton';
import * as styles from './styles';

const { text } = theme;

export const LINE_HEIGHT = text.sm.SMALL.lineHeight;
export const HIDE_TEXT_ON_LINE = 3;

export interface Props {
  textContainerId: string;
  children: JSX.Element[] | JSX.Element;
  hideTextOnLine?: number;
  lineHeight?: number;
  onToggle?: (isOpen: boolean) => void;
}

export const ExpandableTextContainer = ({
  textContainerId,
  children,
  hideTextOnLine = HIDE_TEXT_ON_LINE,
  lineHeight = LINE_HEIGHT,
  onToggle,
}: Props) => {
  const [isExpanded, toggleIsExpanded] = useToggle(false);
  const [unexpandedHeight, setUnexpandedHeight] = useState(lineHeight);
  const { textWrapperRef, lineCount, textHeight } = useLineCount({ lineHeight });

  const handleToggleExpanded = () => {
    toggleIsExpanded(!isExpanded);
    onToggle?.(!isExpanded);
  };

  useEffect(() => {
    setUnexpandedHeight(
      lineCount < hideTextOnLine ? lineHeight * lineCount : lineHeight * hideTextOnLine,
    );
  }, [lineCount]);

  return (
    <div>
      <div
        style={{ height: isExpanded ? textHeight : unexpandedHeight }}
        css={styles.expandingSection}
        data-testid={textContainerId}
      >
        <div ref={textWrapperRef}>{children}</div>
      </div>
      {lineCount > hideTextOnLine && (
        <ExpandableReadMoreButton
          controls={textContainerId}
          toggleExpanded={handleToggleExpanded}
          isExpanded={isExpanded}
        />
      )}
    </div>
  );
};
